import Vuex from 'vuex'
import AuthService from './services/auth.service';
import Vue from "vue";

Vue.use(Vuex)

const user = JSON.parse(localStorage.getItem('user'));

const initialStateUser = user
    ? {status: {loggedIn: true}, user}
    : {status: {loggedIn: false}, user: null};

export default new Vuex.Store({
  state: {
    initialState: initialStateUser,
    ekpFilter: localStorage.getItem('ekpFilter')
  },
  getters: {},
  mutations: {
    loginSuccess(state, user) {
      state.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.loggedIn = false;
    },
    registerFailure(state) {
      state.loggedIn = false;
    },
    refreshToken(state, accessToken) {
      state.loggedIn = true;
      state.user = {...state.user, accessToken: accessToken};
    },
    save_filter(state, filterEkp) {
      state.ekpFilter = filterEkp
    },
    clear_filter(state) {
      state.ekpFilter = ''
    }
  },
  actions: {
    login({commit}, user) {
      return AuthService.login(user).then(
          user => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          },
          error => {
            commit('loginFailure');
            return Promise.reject(error);
          }
      );
    },
    logout({commit}) {
      AuthService.logout();
      commit('logout');
    },
    register({commit}, user) {
      return AuthService.register(user).then(
          response => {
            commit('registerSuccess');
            return Promise.resolve(response.data);
          },
          error => {
            commit('registerFailure');
            return Promise.reject(error);
          }
      );
    },
    refreshToken({commit}, accessToken) {
      commit('refreshToken', accessToken);
    },
    putFilter({commit}, filter) {
      let filterSaved = JSON.stringify(filter);
      localStorage.setItem('ekpFilter', filterSaved)
      return new Promise((resolve, reject) => {
        commit('save_filter', filterSaved)
      })
    }
  }
})
